import React from 'react';
import { generateImageUrl } from '../../utils/imageUtils';

export interface IconImageProps {
	imageId: string;
	variant?: 'small' | 'large';
	className?: string;
	alt?: string;
}

const IconImage: React.FC<IconImageProps> = ({ imageId, variant = 'small', className = 'rich-text-image rich-text-icon', alt }) => {
	const src = generateImageUrl(imageId, 'icon', variant);
	const altText = alt || imageId.replace(/_/g, ' ').replace(/:/g, ' - ');
	const finalClassName = variant === 'large' ? `${className} large` : className;
	return (
		<img
			src={src}
			alt={altText}
			className={finalClassName}
		/>
	);
};

export default IconImage;


